module.exports = __webpack_public_path__ + "img/fuyuanchun.1eed04b8.jpg";